<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14.736" height="20.011" viewBox="0 0 14.736 20.011">
    <g id="Gruppe_64" data-name="Gruppe 64" transform="translate(-158.25 -144.25)">
      <line id="Linie_1" data-name="Linie 1" x2="7" transform="translate(162.212 153.702)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <line id="Linie_3" data-name="Linie 3" x2="7" transform="translate(162.212 159.702)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <line id="Linie_4" data-name="Linie 4" x1="7" transform="translate(162.212 156.702)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Pfad_38" data-name="Pfad 38" d="M174.51,147.057c-.473,0-.8-.5-.984-1.01a1.376,1.376,0,0,0-2.672,0c-.184.515-.511,1.01-.984,1.01H169v2.057a.639.639,0,0,0,.58.686h5.22a.64.64,0,0,0,.58-.686v-2.057Z" transform="translate(-6.572 0)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1.5"/>
      <ellipse id="Ellipse_8" data-name="Ellipse 8" cx="0.5" rx="0.5" transform="translate(165.212 147.702)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Pfad_39" data-name="Pfad 39" d="M169.085,151h2.206a.989.989,0,0,1,.945,1.028v14.4a.989.989,0,0,1-.945,1.028H159.945a.989.989,0,0,1-.945-1.028v-14.4a.989.989,0,0,1,.945-1.028h2.206" transform="translate(0 -3.943)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1.5"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "notesSmall"
}
</script>

<style scoped>

</style>